import React, { useEffect, useState } from 'react'
import { getSitesReportApi } from '../../utils/ApiEndpointFunctions';
import { useSearchParams } from 'react-router-dom';
import Spinwheel from '../../components/common/Spinwheel';
import { useUserContext } from '../../context/userContext';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import toast from 'react-hot-toast';

export default function SuperAdminDailyReport() {
   const [details, setDetails] = useState([])
   const [loading, setLoading] = useState({ details: true })
   const { langPreference } = useUserContext();
   const limit = 10;
   const [page, setPage] = useState(0);
   const [searchParams, setSearchParams] = useSearchParams();
   const [totalCount, setTotalCount] = useState(null);
   const [searchFilter, setSearchFilter] = useState({ from: new Date(), to: new Date(), })

   const getReportList = async () => {
      setLoading({ ...loading, details: true });
      try {
         const page = searchParams.get("page") || 1
         let date = `${searchFilter?.to ? new Date(searchFilter?.to).getTime() + "-" : ""}${searchFilter?.from ? new Date(searchFilter?.from).getTime() : ""}`
         const res = await getSitesReportApi(date, limit, page);
         if (res.status === 200) {
            setDetails(res.data?.data?.report);
            setTotalCount(res.data?.data?.totalCount);
            setPage(Math.ceil(res.data?.data?.totalCount / limit));
         }
      } catch (error) {
         console.log(error)
      }
      setLoading({ ...loading, details: false });
   }

   const handlePageClick = (event) => {
      let currentPage = event.selected + 1;
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", currentPage);
      if (newParams.has("tab")) {
         newParams.set("tab", newParams.get("tab"));
      }
      setSearchParams(newParams);
   };

   useEffect(() => {
      getReportList()
   }, [searchParams.get('page')])

   const handleSearch = () => {
      if (searchFilter?.to && searchFilter?.from) {
         getReportList()
      } else {
         toast.error(langPreference?.range_required || "Please select date range")
      }
   }

   return (
      <>

         <div className="main-content">
            <div className="container-fluid">
               <div className="row">
                  <div className="main-content">
                     <div className="dash-nav1">
                        <div className="d-flex justify-content-between align-items-center">
                           <h3 className="mb-0 font-blue">{langPreference?.daily_report || "Daily Report"}</h3>
                           <div className='d-flex gap-2 align-items-center justify-content-center'>
                              <div className="ed-box">
                                 <label htmlFor="to" className="form-label">{langPreference?.date || "Date"}</label>
                                 <DatePicker
                                    selectsRange={true}
                                    dateFormat="dd/MM/yyyy"
                                    className='form-control cursor-pointer'
                                    startDate={searchFilter?.to ? searchFilter?.to : null}
                                    endDate={searchFilter?.from ? searchFilter?.from : null}
                                    onChange={(update) => {
                                       setSearchFilter({ ...searchFilter, to: update[0], from: update[1] })
                                    }}
                                    isClearable={true}
                                    placeholderText={(langPreference?.from || 'from') + "-" + (langPreference?.to || "to")}
                                    showDisabledMonthNavigation
                                 />
                              </div>
                              <div>
                                 <button className="btn btn-dark me-2 mb-2 mb-md-0 w-auto" type="button" onClick={handleSearch} >
                                    {langPreference?.search || "Search"}
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="d-flex justify-content-end align-items-end">
                        <div className="d-flex align-items-center justify-content-end">
                           <div className="dropdown">

                           </div>
                        </div>
                     </div>
                     {/* <!-- table --> */}
                     <div className="table-responsive" style={{ overflowX: "inherit" }}>
                        <table className="table d-table mt-4">
                           <thead>
                              <tr>
                                 <th scope="col">{langPreference?.site_name || "Site Name"}</th>
                                 <th scope="col-2">{langPreference?.site_address || "SITE Address"}</th>
                                 <th scope="col-8">{langPreference?.company_name || "COMPANY NAME"}</th>
                                 <th scope="col">{langPreference?.purchase_order || "Purchase order"}</th>
                                 <th scope="col">{langPreference?.challan || "Challan"}</th>
                                 <th scope="col">{langPreference?.voucher || "Voucher"}</th>
                              </tr>
                           </thead>
                           {
                              loading?.details ?
                                 <tbody >
                                    <tr>
                                       <td colSpan={12}>
                                          <div className="d-flex justify-content-center">
                                             <Spinwheel />
                                          </div>
                                       </td>
                                    </tr>
                                 </tbody> :

                                 <tbody>
                                    {details?.length > 0 ? details?.map((ele, index) => {
                                       return (
                                          <tr key={index}>
                                             <td>{ele?.name}</td>
                                             <td>{ele?.siteAddress?.address1}</td>
                                             <td>{ele?.company?.name}</td>
                                             <td>{ele?.totalPo}</td>
                                             <td>{ele?.totalChallan}</td>
                                             <td>{ele?.totalVoucher}</td>
                                          </tr>)
                                    }) : <tr className='text-center'>
                                       <td colSpan="12">
                                          <h1>{langPreference?.data_not_found || "Data Not Found"}</h1>
                                       </td>
                                    </tr>}
                                 </tbody>}
                        </table>
                     </div>
                     {totalCount > limit ? (
                        <div className="d-flex justify-content-center">
                           <ReactPaginate
                              nextLabel={`${langPreference?.next_page || "Next"} >`}
                              onPageChange={handlePageClick}
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageCount={page}
                              previousLabel={`< ${langPreference?.previous_page || "Previous"}>`}
                              pageClassName="page-item"
                              pageLinkClassName="page-link"
                              previousClassName="page-item"
                              previousLinkClassName="page-link"
                              nextClassName="page-item"
                              nextLinkClassName="page-link"
                              breakLabel="..."
                              breakClassName="page-item"
                              breakLinkClassName="page-link"
                              containerClassName="pagination"
                              activeClassName={"active"}
                              forcePage={searchParams.get('page') ? Number(searchParams.get('page')) - 1 : 0}
                           />
                        </div>
                     ) : (
                        ""
                     )}
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}
